import { QueryType, SelectOption } from "../models";
import { useRoleQuery, useUserBasicQuery } from "../queries";

export const useUserSelectOptions = (roleMatches: string[], idAsString = true): SelectOption[] => {
    const {
        listQuery: { data: roles },
    } = useRoleQuery({ queryType: QueryType.List });

    const matchingRoleIds =
        roles?.filter((role) => roleMatches.some((match) => role.name.includes(match))).map((role) => role.id) ?? [];

    const {
        listQuery: { data: usersWithRoles },
    } = useUserBasicQuery({ roleIds: matchingRoleIds });

    const userOptions = usersWithRoles?.map((user) => ({
        label: user.name,
        value: idAsString ? user.id.toString() : user.id,
    }));

    return userOptions ?? [];
};
